module.exports = __webpack_public_path__ + "static/media/ff.d267b3a3.svg";